var React = require('react');

function Tiktok (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M48,8H16c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h32c4.418,0,8-3.582,8-8V16C56,11.582,52.418,8,48,8z M50,27 c-3.964,0-6.885-1.09-9-2.695V38.5C41,44.841,35.841,50,29.5,50S18,44.841,18,38.5S23.159,27,29.5,27h2v5h-2 c-3.584,0-6.5,2.916-6.5,6.5s2.916,6.5,6.5,6.5s6.5-2.916,6.5-6.5V14h5c0.018,1.323,0.533,8,9,8V27z"}));
}

Tiktok.defaultProps = {"x":"0px","y":"0px","width":"35","height":"30","viewBox":"0 0 70 62","style":{"marginLeft":"-8px","position":"relative","bottom":"4px"}};

module.exports = Tiktok;

Tiktok.default = Tiktok;
